<template>
    <span :title="tagTitle" :class="tag.icon" class="tag-icon">
        {{ tagTitle }}
    </span>
</template>

<script>
export default {
  name: 'TagIcon',
  data() {
    return {
      tagTitle: this.$options.filters.t(this.tag.title.I18nKey) 
    }
  },
  props: {
    tag: {
      type: Object
    },
  }
}
</script>

<style lang="scss" scoped>
.tag-icon {
  font-family: $font-text;
  cursor: default;
}
</style>
